import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import {
    getListUsers,
    createNewUser,
    getUserById,
    updateUserById,
    deleteUserById,
    banUserById,
    uploadAvatar,
    resetPassword,
} from '../../services/apis/UserAPIServices'
import { getListRoles } from '../../services/apis/RoleAPIServices'
import actions from './actions'
import authActions from '../auth/actions'
import { message } from 'antd'
import { HandleErrorCode } from '../handleErrorCode'
function* saga_GetListUsers(action) {
    try {
        const { params } = action.payload

        let status = 0,
            pageNumber = 1,
            pageSize = 0

        pageNumber = yield select(state => state.user.currentPage)
        pageSize = yield select(state => state.user.numberOfPage)
        let textSearch = yield select(state => state.user.lastTextSearch)

        if (params.status) status = params.status
        if (params.pageNumber) pageNumber = params.pageNumber
        if (params.pageSize) pageSize = params.pageSize

        const response = yield call(
            getListUsers,
            pageNumber,
            pageSize,
            status,
            textSearch
        )

        if (response.error.code === 200) {
            let users = response.data
            let total = response.total

            if (users.length > pageSize) users = users.slice(0, pageSize)

            yield put(actions.action.getListUsersSuccess(users))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                })
            )
        } else {
            const message = response.error.message
            console.error('Get List user call API error : ', message)
        }
    } catch (ex) {
        console.error('Get list user error : ', ex.message)
    }
}

function* saga_SaveCurrentUser() {
    try {
        let currentUser = yield select(state => state.user.currentUser)
        let userInfo = yield select(state => state.auth.userInfo)
        const avatar_file = yield select(state => state.user.avatar_file)

        // upload avatar & update current user
        try {
            if (avatar_file != null) {
                const responseUploadAvatar = yield uploadAvatar(avatar_file)
                const avatar = responseUploadAvatar.uploaded_files[0]
                currentUser = {
                    ...currentUser,
                    ...{
                        avatar,
                    },
                }
            }
        } catch {}

        // put to server
        let response = ''
        if (currentUser.uid === -1) {
            // create user
            response = yield createNewUser(currentUser)
        } else {
            // update user
            response = yield updateUserById(currentUser.uid, currentUser)
        }

        if (response.error.code === 200) {
            if (currentUser.uid === -1) {
                message.success('Thêm người dùng thành công')
            } else {
                message.success('Cập nhật thông tin người dùng thành công')
            }

            const status = yield select(state => state.user._status)

            yield put(actions.action.getListUsers({ status }))

            if (currentUser.uid === userInfo.uid) {
                // update profile
                yield put(authActions.action.getUserInfo())
            }
        } else {
            HandleErrorCode(response.error.code)
            console.error('Save current user error : ', response.error.message)
        }
    } catch (ex) {
        console.error('Save current user error : ', ex.message)
    }
}

function* saga_DeleteUser(action) {
    try {
        const { userId } = action.payload
        const response = yield deleteUserById(userId)

        if (response.error.code === 200) {
            message.success('Xoá người dùng thành công')

            const status = yield select(state => state.user._status)

            yield put(actions.action.getListUsers({ status }))
        } else {
            HandleErrorCode(response.error.code)

            console.error(
                'Delete user call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.log('Delete user error : ', ex.message)
    }
}

function* saga_BanUser(action) {
    try {
        const { userId } = action.payload
        const response = yield banUserById(userId)

        if (response.error.code === 200) {
            message.success('Cấm người dùng thành công')

            const status = yield select(state => state.user._status)

            yield put(actions.action.getListUsers({ status }))
        } else {
            HandleErrorCode(response.error.code)
            console.error('Ban user call API error : ', response.error.message)
        }
    } catch (ex) {
        console.log('Ban user error : ', ex.message)
    }
}

function* saga_GetCurrentUser(action) {
    try {
        const { userId } = action.payload
        const response = yield getUserById(userId)

        if (response.error.code === 200) {
            const userInfo = response.data
            yield put(actions.action.updateState({ currentUser: userInfo }))
        } else {
            console.error('Get current user eror: ', response.error.message)
        }
    } catch (ex) {
        console.log('Get current user error : ', ex.message)
    }
}

function* saga_ChangeCurrentPage(action) {
    try {
        const { pageIndex } = action.payload
        const status = yield select(state => state.user._status)

        yield put(
            actions.action.getListUsers({ status, pageNumber: pageIndex })
        )
    } catch (ex) {
        console.log('Change current page error ', ex.message)
    }
}

function* saga_ChangePageSize(action) {
    try {
        const { numberOfPage } = action.payload
        const status = yield select(state => state.user._status)

        yield put(
            actions.action.getListUsers({
                status,
                pageNumber: 1,
                pageSize: numberOfPage,
            })
        )
    } catch (ex) {
        console.log('Change current page error ', ex.message)
    }
}

function* saga_GetListRoles() {
    try {
        let response = yield call(getListRoles)

        if (response.error.code === 200) {
            let roles = response.data
            yield put(actions.action.getListRolesSuccess(roles))
        } else {
            console.log(
                'Get List User Roles Call API Error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.log('Get List User Roles  error : ', ex.message)
    }
}

function* saga_ResetPasswordUser(action) {
    try {
        const { user, newPassword } = action.payload

        const response = yield call(resetPassword, user, newPassword)
        if (response.error.code === 200) {
            message.success('Đặt lại mật khẩu thành công')
        } else {
            console.log(
                'Reset password call API error : ',
                response.error.message
            )
            message.error('Đặt lại mật khẩu thất bại')
        }
    } catch (ex) {
        console.log('Reset password error : ', ex.message)
        message.error('Đặt lại mật khẩu thất bại')
    }
}

function* saga_SearchUser() {
    try {
        let status = 0,
            pageNumber = 1,
            pageSize = 0

        pageSize = yield select(state => state.user.numberOfPage)
        let textSearch = yield select(state => state.user.textSearch)

        const response = yield call(
            getListUsers,
            pageNumber,
            pageSize,
            status,
            textSearch
        )

        if (response.error.code === 200) {
            let users = response.data
            let total = response.total

            console.log('total : ', total)

            if (users.length > pageSize) users = users.slice(0, pageSize)

            yield put(actions.action.getListUsersSuccess(users))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                    currentPage: 1,
                })
            )
        } else {
            const message = response.error.message
            console.error('Search List user call API error : ', message)
        }
    } catch (ex) {
        console.error('Search list user error : ', ex.message)
    }
}

function* listen() {
    yield takeEvery(actions.type.GET_LIST_USERS, saga_GetListUsers)
    yield takeEvery(actions.type.SAVE_CURRENT_USER, saga_SaveCurrentUser)
    yield takeEvery(actions.type.DELETE_USER, saga_DeleteUser)
    yield takeEvery(actions.type.GET_CURRENT_USER, saga_GetCurrentUser)
    yield takeEvery(actions.type.BAN_USER, saga_BanUser)
    yield takeEvery(actions.type.CHANGE_CURRENT_PAGE, saga_ChangeCurrentPage)
    yield takeEvery(actions.type.CHANGE_NUMBER_OF_PAGE, saga_ChangePageSize)
    yield takeEvery(actions.type.GET_LIST_ROLES, saga_GetListRoles)
    yield takeEvery(actions.type.RESET_PASSWORD_USER, saga_ResetPasswordUser)
    yield takeEvery(actions.type.SEARCH_USER, saga_SearchUser)
}

export default function* userSaga() {
    yield all([fork(listen)])
}
